export default {
    // Production auth and API calls must round-trip through the Front Door-backed URL.
    csharpBackendUrl: 'https://ep-powerbiembed-API-prod-nzn-afd-hsagdcbcc3d4ghcd.a03.azurefd.net',
    clientId: '03e8231b-c148-4559-8ffa-f28f6142fd96',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 2,
};
